var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLok8RCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 120,
    viewBox: "0 0 400 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-150 -720)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10486",
    "data-name": "Path 10486",
    d: "M172.14,720.634V793h29v16.758H150v-89.12Z",
    transform: "translate(0 0.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10487",
    "data-name": "Path 10487",
    d: "M225.7,811.28c-25.766,0-46.743-18.917-46.743-45.7S199.933,720,225.7,720c25.9,0,46.484,18.789,46.484,45.577S251.466,811.28,225.7,811.28Zm0-19.8c14.5,0,23.953-10.285,23.953-25.9,0-15.87-9.452-25.9-23.953-25.9-14.76,0-24.084,10.028-24.084,25.9C201.616,781.19,210.94,791.475,225.7,791.475Z",
    transform: "translate(29.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10488",
    "data-name": "Path 10488",
    d: "M253.779,770.4v39.355H231.637v-89.12h22.142v39.1l30.3-39.1H310.1l-35.218,43.672L311.4,809.754h-27.06Z",
    transform: "translate(81.57 0.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10489",
    "data-name": "Path 10489",
    d: "M351.548,720.634c22.271,0,33.4,12.569,33.4,28.056,0,11.172-6.214,21.71-20.2,25.772l20.977,35.292H360.741l-18.905-33.643h-5.309v33.643h-22.14v-89.12Zm-1.3,18.028H336.527V760.75h13.725c8.288,0,12.172-4.189,12.172-11.17C362.424,742.977,358.54,738.662,350.252,738.662Z",
    transform: "translate(164.27 0.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10490",
    "data-name": "Path 10490",
    d: "M328.388,749.512a30.283,30.283,0,0,0-11.6-6.6c-3.263,1.581-6.911,1.929-9.405,2.316-5.565.867-5.653,4.169-5.653,4.169s.088,3.3,5.653,4.169,16.85,1.534,16.85,16.054c0,9.69-6.156,13.32-12.176,14.554a14.107,14.107,0,0,1-4.221.639q-.715,0-1.41-.068a33.814,33.814,0,0,1-5.753-.4,6.223,6.223,0,0,1-.266,2.128c-.353,1.212-8.965,0-8.965,0v-5.922c0-20.057,3.311-17.653,3.311-31.153,0-1.877-.064-3.444-.174-4.81a30.27,30.27,0,0,0-7.3,4.926,29.139,29.139,0,0,0-4.149,38.625l3.2,3.766,21.507,25.308,21.517-25.324,3.173-3.73a29.156,29.156,0,0,0-4.139-38.646Z",
    transform: "translate(127.595 22.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10491",
    "data-name": "Path 10491",
    d: "M307.837,720.634c-16.661,0-30.168,13.242-30.168,29.577a29.127,29.127,0,0,0,7.208,19.185l.034-.032a33.557,33.557,0,0,1,9.221-5.99c-.96-5.521-2.69-8.28-2.69-22.779v-5.924s8.612-1.212,8.965,0a6.234,6.234,0,0,1,.266,2.129s23.561-4.229,23.561,14.724c0,5.517-1.631,9.037-3.957,11.323a33.718,33.718,0,0,1,10.483,6.517l.036.032A29.126,29.126,0,0,0,338,750.211C338,733.876,324.5,720.634,307.837,720.634Z",
    transform: "translate(127.595 0.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(423.782 742.67)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10492",
    "data-name": "Path 10492",
    d: "M308.525,762.5a10.993,10.993,0,0,1-1.078,3.872l-.124-.066L288.38,756.194l-1.074-.573c.349-1.451.625-2.775.829-4.011l3.257,1.739,16.729,8.933Z",
    transform: "translate(-286.502 -711.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10493",
    "data-name": "Path 10493",
    d: "M309.731,743.471a8.1,8.1,0,0,1-.8,2.13l-1.482-.789-18.955-10.119-1.568-.837a11.882,11.882,0,0,1,.1-2.5l2.568,1.37,18.953,10.117Z",
    transform: "translate(-286.905 -731.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10494",
    "data-name": "Path 10494",
    d: "M307.088,744.893c-.138.124-.282.248-.429.365-.214.176-.439.343-.667.5a12.4,12.4,0,0,1-2.64,1.364c-.08.034-.162.064-.242.094a16.346,16.346,0,0,1-1.735.523l-2.1-1.12-10.407-5.551-.7-.376c-.1-.515-.194-1.052-.293-1.6-.066-.347-.136-.7-.2-1.058-.152-.813-.278-1.562-.389-2.254-.086-.565-.162-1.086-.224-1.575l.543.291,17.8,9.5Z",
    transform: "translate(-286.746 -728.49)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLok8RCenter);
export default __webpack_public_path__ + "static/media/lok8r_center.33f7043f0f34934b0514b3192ce75d4b.svg";
export { ForwardRef as ReactComponent };